import { get, isEmpty } from "lodash";
import { getCompanyId, getUserId } from "src/utils";
import moment from "moment";
import { DATE_TO_STORE } from "src/constants";
import { displayRating } from "src/utils/general";
import { useRecoilValue } from "recoil";
import { metaDataDetails } from "Recoil/LoggedInUserDetail/selector";
import { targetDetailsState } from "Recoil/Targets/atom";

export const useFormattedData = () => {
  const { performancerating } = useRecoilValue(metaDataDetails);
  const targetDetails = useRecoilValue(targetDetailsState);

  const individualUserSearchFormat = (users) => {
    return (users || []).map((user) => {
      const id = get(user, "userid", "")
        ? get(user, "userid", "")
        : get(user, "coachid", "")
        ? get(user, "coachid", "")
        : get(user, "id", "");
      return {
        id,
        isSoftDelete: user?.isSoftDelete || false,
        name: `${get(user, "firstName", "")} ${get(user, "lastName", "")}`,
        firstName: get(user, "firstName", ""),
        lastName: get(user, "lastName", ""),
        profileImage: get(user, "profileImage.fileName", ""),
        department: get(user, "department", ""),
        role: get(user, "role", ""),
        title: get(user, "designation", ""),
        supervisor: get(user, "supervisor", {}),
        supervisorName: `${get(user, "supervisor.firstName", "")} ${get(
          user,
          "supervisor.lastName",
          ""
        )}`,
        weightage: get(user, "totalWeightage", "0"),
        isAddedFromBE: get(user, "isAddedFromBE", false),
        selected: false,
        show: true,
        disabled: false,
        userInGroup: false,
        isCoach: get(user, "isCoach", false),
        userStatus: user?.status,
      };
    });
  };

  const groupUserSearchFormat = (groups) => {
    return (groups || []).map((res) => {
      return {
        ...res,
        id: get(res, "groupId", ""),
        users: individualUserSearchFormat(get(res, "users", [])),
        selected: false,
        expanded: false,
        show: true,
        disabled: false,
      };
    });
  };

  const departmentUserSearchFormat = (departments) => {
    return (departments || []).map((res) => {
      return {
        ...res,
        users: individualUserSearchFormat(get(res, "users", [])),
        id: get(res, "department", ""),
        name: get(res, "department", ""),
        selected: false,
        expanded: false,
        show: true,
        disabled: false,
      };
    });
  };

  const userRatingFormat = (users, name) => {
    return (users || []).map((userInfo) => {
      const completedCheckin = get(userInfo, "checkinCompleted", 0);
      const totalCheckin = get(userInfo, "totalCheckin", 0);
      const checkNaForCheckin =
        completedCheckin === null || totalCheckin === null
          ? "NA"
          : `${completedCheckin || "0"}/${totalCheckin || "0"}`;

      const checkNaForObjectives =
        get(userInfo, "objectivesCompleted", 0) === null ||
        get(userInfo, "totalObjectives", 0) === null
          ? "NA"
          : `${get(userInfo, "objectivesCompleted", 0) || "0"}/${
              get(userInfo, "totalObjectives", 0) || "0"
            }`;

      /* const rating = (get(userInfo, "selfRating", "") || "").length
        ? JSON.parse(
            performancerating.find(i => i.name === get(userInfo, "selfRating", ""))
              .value
          ).rating
        : null; */

      const rating =
        !isEmpty(get(userInfo, "selfRating")) && !isEmpty(performancerating)
          ? displayRating(
              [...performancerating],
              get(userInfo, "selfRating", "")
            )
          : "-";

      const leadReviewerRating =
        !isEmpty(get(userInfo, "leadReviewerRating")) &&
        !isEmpty(performancerating)
          ? displayRating(
              [...performancerating],
              get(userInfo, "leadReviewerRating", "")
            )
          : "-";
      const findCoachRating = userInfo?.coachRatings?.find(
        (res) => res?.id === getUserId()
      );
      const coachRating =
        !isEmpty(findCoachRating) && !isEmpty(performancerating)
          ? displayRating(
              [...performancerating],
              get(findCoachRating, "rating", "")
            )
          : "-";
      const coachComment = findCoachRating?.comment;
      const status = userInfo?.userTargetStatus;
      const userStatus = userInfo?.user?.status;
      const ratingSubmitted = userInfo?.ratingSubmitted;
      const { user } = userInfo;
      let addUser = false;
      let isCompleted = false;
      let selected = false;

      if (name === "coachRating") {
        if (!targetDetails?.completionApprovalRequired) {
          if (coachRating !== "-" && (leadReviewerRating || rating) !== "-") {
            selected = true;
            addUser = true;
          } else if (
            coachRating === "-" &&
            !ratingSubmitted &&
            status === "COMPLETED"
          ) {
            // Status is completed but rating not submitted then addUser
            addUser = true;
            selected = true;
          }
        } else {
          if (
            (rating !== "-" || leadReviewerRating !== "-") &&
            coachRating === "-"
          ) {
            selected = true;
            addUser = true;
          }
        }
      } else if (name === "leadReviewerRating" && userInfo[name] !== "-") {
        if (
          targetDetails?.completionApprovalRequired &&
          (rating !== "-" || coachRating !== "-") &&
          leadReviewerRating === "-"
        ) {
          selected = true;
          addUser = true;
        } else if (
          !targetDetails?.completionApprovalRequired &&
          leadReviewerRating === "-" &&
          status === "COMPLETED"
        ) {
          selected = true;
          addUser = true;
        }
      }
      // if (status === "PENDINGAPPROVAL" && rating !== "-") {
      //   addUser = true;
      //   selected = true;
      // } else if (status === "COMPLETED" && user?.[name] !== "-") {
      //   // Status is completed but rating not submitted then addUser
      //   addUser = true;
      //   selected = true;
      // } else if (status === "COMPLETED" && !ratingSubmitted) {
      //   // Status is completed but rating not submitted then addUser
      //   addUser = true;
      //   selected = true;
      // } else if (userInfo?.selfRating && status !== "COMPLETED") {
      //   // For save and exit
      //   addUser = true;
      //   selected = true;
      // }

      return {
        userTargetId: userInfo?.id,
        id: user?.id,
        name: `${user?.firstName} ${user?.lastName}`,
        firstName: user?.firstName,
        lastName: user?.lastName,
        profileImage: user?.profileImage?.fileName,
        department: user?.department,
        checkins: checkNaForCheckin,
        objectives: checkNaForObjectives,
        selfRating: rating,
        leadReviewerRating,
        coachRating,
        coachComment,
        title: user?.designation,
        rating:
          name === "coachRating"
            ? coachRating !== "-"
              ? coachRating
              : ""
            : userInfo?.rating || "",
        comment:
          name === "coachRating" ? coachComment : userInfo?.comment || "",
        ratingSubmitted,
        status: status, // === "PENDINGAPPROVAL" ? "Pending" : status,
        selected,
        //disabled: ["COMPLETED"].includes(status),
        addUser,
        isCompleted,
        userStatus,
        isHide: false,
      };
    });
  };

  const createVisionVariables = (formData) => {
    const variables = {
      input: {
        title: get(formData, "details.title", ""),
        description: get(formData, "details.description", ""),
        startDate: moment(get(formData, "details.startDate")).format(
          DATE_TO_STORE
        ),
        requireEndDate: get(formData, "details.hasEndDate", true),
        visibilityOption: get(formData, "visibility.option"),
        visionCompanyId: getCompanyId(),
        generateSharableLink: get(formData, "visibility.generateLink", true),
        linkTarget: get(formData, "details.linkedTargets.targetsData", []).map(
          (res) => {
            return { id: res.id };
          }
        ),
        createdByUserId: getUserId(),
        // enableComments
      },
    };
    if (get(formData, "visibility.option") === "SelectedGroup") {
      variables.input.tagUsersToVision = {
        users: get(formData, "visibility.assignPeople.userListData", [])
          .filter((res) => res.selected)
          .map((res) => {
            return {
              isSelected: true,
              userid: res.id,
            };
          }),
      };
    }
    if (get(formData, "details.endDate")) {
      variables.input.endDate = moment(get(formData, "details.endDate")).format(
        DATE_TO_STORE
      );
    }
    if (get(formData, "coverPhoto.base64")) {
      variables.input.logo = {
        base64Data: get(formData, "coverPhoto.base64"),
      };
    } else if (get(formData, "coverPhoto.fileDetails.uploadUrl")) {
      variables.input.logo = {
        url: get(formData, "coverPhoto.fileDetails.url", ""),
        fileName: get(formData, "coverPhoto.fileDetails.fileName", ""),
        key: get(formData, "coverPhoto.fileDetails.key", ""),
        uploadUrl: get(formData, "coverPhoto.fileDetails.uploadUrl", ""),
      };
    }
    if (formData.id) {
      variables.input.id = formData.id;
    }
    return variables;
  };

  return {
    individualUserSearchFormat,
    groupUserSearchFormat,
    departmentUserSearchFormat,
    userRatingFormat,
    createVisionVariables,
  };
};
